import PropTypes from 'prop-types'

export const Style = PropTypes.oneOf(['primary', 'secondary', 'success', 'info', 'warning', 'error'])

export const defaultClassName = ''
export const defaultChildren = null

export const defaultPropTypes = {
  defaultClassName,
  defaultChildren,
}

export default {
  Style,
  className: PropTypes.string,
  children: PropTypes.node,
}
